import CSSFadeIn from '@components/Transitions/Transitions.CSS.FadeIn'
import FadeIn from '@components/Transitions/Transitions.FadeIn'
import FadeScroll from '@components/Transitions/Transitions.FadeScroll'

export default {
  CSS: {
    FadeIn: CSSFadeIn,
  },
  FadeIn,
  FadeScroll,
}
